import React from "react";

export default function Dialog({
  open,
  onClose,
  otp,
  setOtp,
  onSubmit,
  onResend,
  isResending,
  isSubmitting,
  message,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-xs flex flex-col gap-4">
        <h2 className="text-lg font-semibold text-center mb-2 text-black">
          OTP has been sent to your phone 
        </h2>
        {message && (
          <div className="text-center text-gray-700 text-xs mb-2">
            {message}
          </div>
        )}
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
          max={6}
          className="border rounded px-3 py-2 text-center text-black"
        />
        <button
          className="bg-blue-600 text-white rounded px-4 py-2 font-semibold"
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
        <button
          className="text-gray-500 underline mt-1"
          onClick={onResend}
          disabled={isResending}
        >
          {isResending ? "Resending..." : "Resend OTP"}
        </button>
        <button
          className="mt-2 text-sm text-red-500"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
